module.exports = "https://and-static.ghzs.com/web/bbs-mobile/static/img/anli_Star_blue.f09ea.png";